/* Featured Collection Slider (scoped, no external deps)
 * - Initializes sliders for elements with `.featured-collection--slider`
 * - Uses native horizontal scrolling + scroll snap
 * - Pagination dots navigate slides and reflect active slide
 * - Disables on mobile when mobile_scrollable is enabled
 */
(function () {
  function throttle(fn, wait) {
    var last = 0, timer;
    return function () {
      var now = Date.now();
      var ctx = this, args = arguments;
      if (now - last >= wait) {
        last = now;
        fn.apply(ctx, args);
      } else {
        clearTimeout(timer);
        timer = setTimeout(function () {
          last = Date.now();
          fn.apply(ctx, args);
        }, wait - (now - last));
      }
    };
  }

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function initSlider(root) {
    if (!root) return;
    
    // Check if mobile_scrollable is enabled
    var container = root.closest('[data-section-type="collection-grid"]');
    var isMobileScrollable = container && container.querySelector('.page-width--flush-small');
    
    // Disable slider on mobile if mobile_scrollable is enabled
    if (isMobile() && isMobileScrollable) {
      root.style.display = 'none';
      return;
    }
    
    var scroller = root.querySelector('.fc-track');
    if (!scroller) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.fc-dot'));

    function goTo(idx) {
      var width = scroller.clientWidth || 1;
      scroller.scrollTo({ left: idx * width, behavior: 'smooth' });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = parseInt(dot.getAttribute('data-index') || '0', 10) || 0;
        goTo(idx);
      });
    });

    function setActive() {
      var width = scroller.clientWidth || 1;
      var idx = Math.round(scroller.scrollLeft / width);
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    scroller.addEventListener('scroll', throttle(setActive, 100));
    
    var resizeHandler = throttle(function() {
      // Re-check mobile state on resize
      if (isMobile() && isMobileScrollable) {
        root.style.display = 'none';
      } else {
        root.style.display = '';
        setActive();
      }
    }, 150);
    
    window.addEventListener('resize', resizeHandler);
    setActive();

    // Mouse/touch drag to scroll (hand gesture on desktop) - only on desktop
    if (!isMobile()) {
      var isDown = false, startX = 0, startY = 0, startLeft = 0, dragged = false, downTarget = null;
      var dragThreshold = 0, movementMultiplier = 16;
      function posX(e) { return (e.touches && e.touches[0] ? e.touches[0].pageX : (e.pageX != null ? e.pageX : e.clientX)); }
      function posY(e) { return (e.touches && e.touches[0] ? e.touches[0].pageY : (e.pageY != null ? e.pageY : e.clientY)); }
      function onDown(e) {
        isDown = true;
        startX = posX(e);
        startY = posY(e);
        startLeft = scroller.scrollLeft;
        scroller.style.scrollSnapType = 'none';
        dragged = false;
        downTarget = e && e.target ? e.target : null;
        try { if (downTarget && downTarget.tagName && downTarget.tagName.toLowerCase() === 'img') downTarget.setAttribute('draggable','false'); } catch(_){ }
      }
      function onMove(e) {
        if (!isDown) return;
        var dx = posX(e) - startX;
        var dy = posY(e) - startY;
        if (Math.abs(dx) > Math.abs(dy)) {
          if (Math.abs(dx) > dragThreshold) {
            if (!dragged) {
              dragged = true;
              scroller.classList.add('is-dragging');
            }
            scroller.scrollLeft = startLeft - (dx * movementMultiplier);
            if (e.cancelable) e.preventDefault();
          }
        }
      }
      function onUp() {
        if (!isDown) return;
        isDown = false;
        scroller.classList.remove('is-dragging');
        var width = scroller.clientWidth || 1;
        var idx = Math.round(scroller.scrollLeft / width);
        scroller.style.scrollSnapType = '';
        scroller.scrollTo({ left: idx * width, behavior: 'smooth' });
        if (dragged) {
          var swallow = function(ev){
            try {
              if (!downTarget) return;
              if (downTarget === ev.target || (downTarget.contains && downTarget.contains(ev.target))) {
                ev.preventDefault(); ev.stopPropagation();
              }
            } catch(_){ }
            document.removeEventListener('click', swallow, true);
          };
          document.addEventListener('click', swallow, true);
          setTimeout(function(){ document.removeEventListener('click', swallow, true); }, 300);
        }
        dragged = false;
        downTarget = null;
      }

      try {
        var elements = root.querySelectorAll('*');
        for (var i = 0; i < elements.length; i++) {
          elements[i].setAttribute('draggable', 'false');
          elements[i].style.userSelect = 'none';
        }
      } catch(_){ }

      var hasPointer = 'PointerEvent' in window;
      if (hasPointer) {
        scroller.addEventListener('pointerdown', onDown, { passive: true });
        window.addEventListener('pointermove', onMove, { passive: false });
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
        window.addEventListener('pointerleave', onUp);
      } else {
        scroller.addEventListener('mousedown', onDown);
        document.addEventListener('mousemove', onMove, { passive: false });
        document.addEventListener('mouseup', onUp);
        scroller.addEventListener('touchstart', onDown, { passive: true });
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onUp);
        document.addEventListener('touchcancel', onUp);
      }
    }
  }

  function initAll() {
    var nodes = document.querySelectorAll('.featured-collection--slider');
    for (var i = 0; i < nodes.length; i++) initSlider(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();